import type { PageThemeDefinition } from "../types";

/** G PERYA — 主色 #C93F55 */
export const gpTheme: PageThemeDefinition = {
  id: "gp",
  labelKey: "robot.setting.page_theme.gp",
  preview: {
    background: "#14080C",
    cardBg: "#1F1014",
    text: "#ffffff",
  },
  tokens: {
    background: "#14080C",
    cardBg: "#1F1014",
    text: "#ffffff",
    textSecondary: "#D4A0AA",
    border: "#4A2830",
    headerBg: "#14080C",
    inputBg: "#1F1014",
    messageBg: "#1F1014",
    senderBg: "#1F1014",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#5A3040",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#2A1418",
    accent: "#C93F55",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#2A1418",
    chatAgentBubbleBorder: "#4A2830",
    chatUserGradientStart: "#C93F55",
    chatUserGradientEnd: "#8E2D3F",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#14080C",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#D4A0AA",
    chatMediaBg: "#14080C",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#FFD54F",
  },
};
